import { Avatar, AVATAR_HEIGHT_24 } from '../../../Avatar'
import { TableCellBase } from '../TableCellBase'
import { TableEmptyCell } from '../TableEmptyCell'

function TableIconCell({ Icon, ...cellProps }) {
  return Icon ? (
    <TableCellBase {...cellProps}>
      <Avatar Icon={Icon} size={AVATAR_HEIGHT_24} />
    </TableCellBase>
  ) : (
    <TableEmptyCell {...cellProps} />
  )
}

export default TableIconCell
